<!--
  La marca del modo soporte de respaldo (9.1) se inserta acá, antes de las pantallas, cuando hay
  una sesión de soporte y ningún layout dibuja la suya. Ver `App.marcaDeRespaldo`.
-->
<ng-container #marcaDeRespaldo></ng-container>
<router-outlet></router-outlet>
